var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-alert',{attrs:{"outlined":"","text":"","dense":"","color":_vm.color,"icon":"mdi-record-circle-outline"}},[_c('span',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }